export default __webpack_public_path__ + "static/media/image.9e4c761c.png";